import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/acm-bg-logo.png';

function Header() {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 570) {
        setScrolling(true); // Trigger animation
      } else {
        setScrolling(false); // Reset animation
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`navbar-header ${scrolling ? 'scroll-glow animate' : 'scroll-glow'}`}>
      <nav className='navbar web-view'>
        <a href='/'>
          <img src={logo} alt='acm-logo' />
        </a>

        <ul>
          <li>
            <NavLink className='a' to="/" exact activeClassName="active">↗ Home</NavLink>
          </li>
          <li>
            <NavLink className='a about' to="/About ACM" activeClassName="active">↗ About ACM</NavLink>
          </li>
          <li>
            <NavLink className='a' to="/Board" activeClassName="active">↗ Community</NavLink>
          </li>
          <li>
            <NavLink className='a' to="/Resources" activeClassName="active">↗ Events</NavLink>
          </li>
          <li>
            <NavLink className='a' to="/gallery" activeClassName="active">↗ Gallery</NavLink>
          </li>
        </ul>
      </nav>

      <nav className='navbar mobile-view'>
        <nav role="navigation">
          <div id="menubtn">
            <input type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
            <ul id='menus'>
              <li>
                <NavLink className='a' to="/" exact activeClassName="active">↗ Home</NavLink>
              </li>
              <li>
                <NavLink className='a about' to="/About ACM" activeClassName="active">↗ About ACM</NavLink>
              </li>
              <li>
                <NavLink className='a' to="/Board" activeClassName="active">↗ Community</NavLink>
              </li>
              <li>
                <NavLink className='a' to="/resources" activeClassName="active">↗ Events</NavLink>
              </li>
              <li>
                <NavLink className='a' to="/gallery" activeClassName="active">↗ Gallery</NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </nav>
    </header>
  );
}

export default Header;
